import ValidatedDateInput from './ValidatedDateInput';
import ValidatedEmailInput from './ValidatedEmailInput';
import ValidatedNumberInput from './ValidatedNumberInput';
import ValidatedPhoneInput from './ValidatedPhoneInput';
import ValidatedSelectInput from './ValidatedSelectInput';
import ValidatedAutocompleteInput from './ValidatedAutocompleteInput';
import ValidatedTextInput from './ValidatedTextInput';
import ValidatedInput from './ValidatedInput';
import ButtonGroupInput from './ButtonGroupInput';
import SearchTextInput from './SearchTextInput';
import ValidatedFieldInput from './ValidatedFieldInput';
import ValidatedMonthlyInput from './ValidatedMonthlyInput';

export default {
    ValidatedDateInput,
    ValidatedEmailInput,
    ValidatedNumberInput,
    ValidatedPhoneInput,
    ValidatedSelectInput,
    ValidatedAutocompleteInput,
    ValidatedTextInput,
    ValidatedInput,
    ButtonGroupInput,
    SearchTextInput,
    ValidatedFieldInput,
    ValidatedMonthlyInput,
};